var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jd-loading-box",class:{ 'is-overlay':_vm.overlay }},[_c('div',{staticClass:"loading-img-box"},[_c('img',{staticClass:"loading-img",attrs:{"src":_vm.$globalCdn + '/images/public/loading.gif',"alt":""}})]),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }